// CRUD chuẩn cho một tính năng: createFeatureAPI('/daily-reports') → { getList, getById, create, update, delete }
// Chép từ PE_Form/src/services/feature-api.js, bỏ các API tính năng chưa có ở THM.
import { fetchWithTimeout, API_BASE_URL } from './API';
import { handleUnauthorized } from './auth-events';

const authHeaders = (accessToken) => ({
  accept: '*/*',
  'x-access-token': accessToken,
  'Content-Type': 'application/json',
});

// API trả { statusCode, data } → bóc data; 401 → phát sự kiện auth:expired (AuthWrapper đưa về /login)
const handleResponse = async (response) => {
  if (response.ok) {
    const json = await response.json().catch(() => ({}));
    return { success: true, data: json.data !== undefined ? json.data : json };
  }
  if (response.status === 401) {
    handleUnauthorized('token_invalid');
    return { success: false, error: 'Phiên đăng nhập đã hết hạn. Đang chuyển sang trang đăng nhập...' };
  }
  const errorData = await response.json().catch(() => ({}));
  return { success: false, error: errorData.message || `HTTP ${response.status}` };
};

const createFeatureAPI = (resourcePath) => ({
  getList: async (accessToken, filters = {}) => {
    try {
      const { month, year, fromDate, toDate, pageSize = 999 } = filters;
      const params = new URLSearchParams();
      if (month != null && month !== '') params.append('month', month);
      if (year != null && year !== '') params.append('year', year);
      if (fromDate) params.append('fromDate', fromDate);
      if (toDate) params.append('toDate', toDate);
      params.append('pageSize', String(pageSize));
      const response = await fetchWithTimeout(`${API_BASE_URL}${resourcePath}?${params}`, { method: 'GET', headers: authHeaders(accessToken) });
      return handleResponse(response);
    } catch (error) {
      return { success: false, error: error.message };
    }
  },
  getById: async (accessToken, id) => {
    try {
      const response = await fetchWithTimeout(`${API_BASE_URL}${resourcePath}/${id}`, { method: 'GET', headers: authHeaders(accessToken) });
      return handleResponse(response);
    } catch (error) {
      return { success: false, error: error.message };
    }
  },
  // noRetry: POST 2 lần = 2 bản ghi
  create: async (accessToken, data) => {
    try {
      const response = await fetchWithTimeout(`${API_BASE_URL}${resourcePath}`, { method: 'POST', headers: authHeaders(accessToken), body: JSON.stringify(data), noRetry: true });
      return handleResponse(response);
    } catch (error) {
      return { success: false, error: error.message };
    }
  },
  update: async (accessToken, id, data) => {
    try {
      const response = await fetchWithTimeout(`${API_BASE_URL}${resourcePath}/${id}`, { method: 'PUT', headers: authHeaders(accessToken), body: JSON.stringify(data), noRetry: true });
      return handleResponse(response);
    } catch (error) {
      return { success: false, error: error.message };
    }
  },
  delete: async (accessToken, id) => {
    try {
      const response = await fetchWithTimeout(`${API_BASE_URL}${resourcePath}/${id}`, { method: 'DELETE', headers: authHeaders(accessToken), noRetry: true });
      return handleResponse(response);
    } catch (error) {
      return { success: false, error: error.message };
    }
  },
});

export const DailyReportAPI = createFeatureAPI('/daily-reports');

// Số liệu màn hình chính: { 'daily-report': { total } } — key trùng key trong featureDisplayConfig.json
export const DashboardAPI = {
  getStats: async (accessToken, month, year) => {
    try {
      const params = new URLSearchParams();
      if (month != null) params.append('month', month);
      if (year != null) params.append('year', year);
      const response = await fetchWithTimeout(`${API_BASE_URL}/dashboard/stats?${params}`, { method: 'GET', headers: authHeaders(accessToken) });
      return handleResponse(response);
    } catch (error) {
      return { success: false, error: error.message };
    }
  },
};

export default createFeatureAPI;
